export function shouldOpenTitlePopover(
  query: string | undefined,
  selectGroup: {
    level: string | null;
    group: string | null;
  } | null,
  opts?: { group?: string; level?: string; minLen?: number },
): boolean {
  const targetGroup = opts?.group ?? "Alle afdelinger";
  const targetLevel = opts?.level ?? "Alle roller";
  const minLen = opts?.minLen ?? 3;

  const isSpecial =
    (selectGroup?.group ?? null) === targetGroup &&
    (selectGroup?.level ?? null) === targetLevel;

  return isSpecial ? (query?.trim().length ?? 0) > minLen : true;
}
